import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminPeopleNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('person');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
